(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name main.sessions.controller:sessionsCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats.main.sessions')
    .controller('EntitatsMainSessionsCtrl', EntitatsMainSessionsCtrl);

  function EntitatsMainSessionsCtrl(Notification, usuarissessioData,  $locale, HelperFactory, $state, $rootScope, $stateParams, $scope,$mdDialog,$document,$window) {
    var vm = this;
    vm.ctrlName = 'EntitatsMainSessions';
    vm.usuarisensessio=usuarisensessio;
    vm.productes = usuarissessioData.data;
    vm.viewuser=viewuser;

   



    if (angular.isUndefined($stateParams.idEntitat) || $stateParams.idEntitat === null || !$stateParams.idEntitat) {
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': false});
    }
    else {
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': true});
    }

    function usuarisensessio(usuarisensessio) {

      $mdDialog.show({
        controller: function DialogController($scope, $mdDialog,$translate) {
          var vm = this;
          vm.usuarisensessio=usuarisensessio;


          $scope.hide = function() {
            $mdDialog.cancel();
          };
          $scope.cancel = function() {
            $mdDialog.cancel();
          };
        },

        controllerAs: 'ctrl',
        templateUrl: 'entitats/main/sessions/usuarisensessio.tpl.html',
        parent: angular.element($document.body),
        clickOutsideToClose:true
      });
    }
 
    function viewuser(id) {
      HelperFactory.setParams($stateParams, {'idUsuari': id});
        var url = $state.href('usuaris.main.submain.dades', $stateParams, {'reload': 'usuaris.main.submain'});
        $window.open(url,'_blank');
    }
  }
}());
